import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Nav, Modal, Form, Badge } from 'react-bootstrap';
import { Briefcase, Mail, LogOut, Plus, Pencil, Trash2, Eye, FileText, MessageSquare, ChevronLeft, ChevronRight, Users, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import './AdminDashboard.css';

const AdminDashboard = ({ setIsAuthenticated }) => {
  const [activeTab, setActiveTab] = useState('jobs');
  const [showModal, setShowModal] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [messages, setMessages] = useState([]);
  const [adminEmail, setAdminEmail] = useState('');

  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  // --- State for messages ---
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showMessageModal, setShowMessageModal] = useState(false);

  // --- State for jobs ---
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [newJob, setNewJob] = useState({
    title: '', location: '', category: 'Warehouse Associates', industry: 'Development',
    salary: '$15,000 - $20,000', type: 'Full Time', careerLevel: 'Executive',
    experience: '2 Years', gender: 'Both', industry: 'Management',
    qualification: 'Diploma', description: '', status: 'active'
  });

  const categories = ['Accounting', 'Administrative Assistants', 'CDL A and B Drivers', 'Culinary & Restaurants', 'Customer Service', 'Electronics & Manufacturing', 'Forklift Operators', 'Warehouse Associates'];
  const salaryRanges = ['0 - $15,000', '$15,000 - $20,000', '$20,000 - $30,000', '$30,000 - $50,000', '$50,000+'];
  const careerLevels = ['Manager', 'Officer', 'Student', 'Executive', 'Others'];
  const industry = ['Development', 'Management', 'Finance', 'Html Department', 'Seo', 'Banking', 'Designing'];
  const experiences = ['Fresh', 'Less than 1 Year', '2 Years', '3 Years', '4 Years', '5 Years', '6 Years', '7 Years', '8 Years +'];
  const qualifications = ['Certificate', 'Diploma', 'Associate Degree', 'Bachelor Degree', 'Master’s Degree', 'Doctorate Degree'];

  useEffect(() => {
    if (!token) {
      navigate('/admin-portal-access');
    } else {
      try {
        const decoded = jwtDecode(token);
        setAdminEmail(decoded.email);
      } catch (error) {
        navigate('/admin-portal-access');
      }
    }
  }, [navigate, token]);

  // --- API Calls ---
  const fetchJobs = async () => {
    try {
      //const response = await fetch('http://localhost:5000/api-portal/jobs');
      const response = await fetch('/api-portal/jobs');
      if (response.ok) {
        const data = await response.json();
        setJobs(data);
      }
    } catch (error) { console.error(error); }
  };

  const fetchMessages = async () => {
    try {
      //const response = await fetch('http://localhost:5000/api-portal/admin/messages', {
      const response = await fetch('/api-portal/admin/messages', {
        headers: { 'Authorization': token }
      });
      if (response.ok) {
        const data = await response.json();
        setMessages(data);
      }
    } catch (error) { console.error(error); }
  };

  useEffect(() => {
    if (activeTab === 'jobs') fetchJobs();
    if (activeTab === 'messages') fetchMessages();
  }, [activeTab]);

  // --- Handlers ---
  const handleSubmitJob = async (e) => {
    e.preventDefault();
    //const url = isEditMode ? `http://localhost:5000/api-portal/jobs/${selectedJob.id}` : 'http://localhost:5000/api-portal/jobs';
    const url = isEditMode ? `/api-portal/jobs/${selectedJob.id}` : '/api-portal/jobs';
    const method = isEditMode ? 'PUT' : 'POST';

    try {
      const response = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify(newJob)
      });
      if (response.ok) {
        setShowModal(false);
        fetchJobs();
      }
    } catch (error) { console.error(error); }
  };

  const handleDeleteJob = async (id) => {
    if (window.confirm("Delete this job posting?")) {
      //await fetch(`http://localhost:5000/api-portal/jobs/${id}`, {
      await fetch(`/api-portal/jobs/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': token }
      });
      fetchJobs();
    }
  };

  const handleDeleteMessage = async (id) => {
    if (window.confirm("Delete this message?")) {
      //await fetch(`http://localhost:5000/api-portal/admin/messages/${id}`, {
      await fetch(`/api-portal/admin/messages/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': token }
      });
      fetchMessages();
    }
  };

  // --- This is for Job Requests on dashboard ---
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    //const response = await fetch('http://localhost:5000/api-portal/admin/requests', {
    const response = await fetch('/api-portal/admin/requests', {
      headers: { 'Authorization': token }
    });
    if (response.ok) {
      const data = await response.json();
      setRequests(data);
    }
  };

  // Dodaj u useEffect
  useEffect(() => {
    if (activeTab === 'jobs') fetchJobs();
    if (activeTab === 'messages') fetchMessages();
    if (activeTab === 'requests') fetchRequests();
  }, [activeTab]);


  const getTitle = () => {
    switch (activeTab) {
      case 'jobs': return 'Job Postings';
      case 'messages': return 'Inbox Messages';
      case 'requests': return 'Job Applications';
      case 'employer': return 'Employer Inquiries';
      default: return 'Dashboard';
    }
  };

  // 1. State for looking at cover letter
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showRequestModal, setShowRequestModal] = useState(false);

  // 2. Function for deleting requests
  const handleDeleteRequest = async (id) => {
    if (window.confirm("Are you sure you want to delete this application?")) {
      try {
        //const response = await fetch(`http://localhost:5000/api-portal/admin/requests/${id}`, {
        const response = await fetch(`/api-portal/admin/requests/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': token // Check if the token is defined on top of conponent
          }
        });

        if (response.ok) {
          // Option A: Get the data from server again
          fetchRequests();

          // Option B: Manualy remove from state(it's faster)
          setRequests(prev => prev.filter(req => req.id !== id));
        } else {
          alert("Failed to delete the request.");
        }
      } catch (error) {
        console.error("Error deleting request:", error);
        alert("An error occurred while deleting.");
      }
    }
  };

  // --- State of pagination ---
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Reset page on 1 when switching tab
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  // We first define what is employer and whats is a general message
  const employerInquiries = messages.filter(m => m.subject && m.subject.startsWith('Employer Inquiry:'));
  const generalMessages = messages.filter(m => !m.subject || !m.subject.startsWith('Employer Inquiry:'));

  // --- Calculaton login (Universal) ---
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Cutouts for every table
  const currentJobs = jobs.slice(indexOfFirstItem, indexOfLastItem);
  const currentMessages = generalMessages.slice(indexOfFirstItem, indexOfLastItem);
  const currentRequests = requests.slice(indexOfFirstItem, indexOfLastItem);

  // Function for changeing the page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Helper function for rendering pagination
  const renderPagination = (totalItems) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (totalPages <= 1) return null;

    return (
      <div className="pagination-wrapper d-flex justify-content-center mt-4 pb-3">
        <Button
          variant="light"
          className="page-control-btn me-2"
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeft size={18} />
        </Button>

        {[...Array(totalPages)].map((_, index) => (
          <Button
            key={index + 1}
            onClick={() => paginate(index + 1)}
            className={`page-number-btn me-2 ${currentPage === index + 1 ? 'active' : ''}`}
          >
            {index + 1}
          </Button>
        ))}

        <Button
          variant="light"
          className="page-control-btn"
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRight size={18} />
        </Button>
      </div>
    );
  };

  // Filtering messages based on title (Subject)
  const currentEmployerRequests = employerInquiries.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="admin-dashboard-wrapper">
      <Row className="g-0">
        {/* Sidebar */}
        <Col md={2} className="admin-sidebar d-flex flex-column">
          <div className="sidebar-header">
            <h4 className="text-white">Infiniti <span className="blue-text">Portal</span></h4>
          </div>
          <Nav className="flex-column mt-4 px-3">
            <Nav.Link className={`sidebar-link ${activeTab === 'jobs' ? 'active-link' : ''}`} onClick={() => setActiveTab('jobs')}>
              <Briefcase size={18} className="me-2" /> Manage Jobs
            </Nav.Link>
            <Nav.Link className={`sidebar-link ${activeTab === 'messages' ? 'active-link' : ''}`} onClick={() => setActiveTab('messages')}>
              <Mail size={18} className="me-2" /> Messages
            </Nav.Link>
            <Nav.Link
              className={`sidebar-link ${activeTab === 'requests' ? 'active-link' : ''}`}
              onClick={() => setActiveTab('requests')}
            >
              <Users size={18} className="me-2" /> Job Requests
            </Nav.Link>

            {/* Employer Requests - Building2 pravi jasnu razliku između kandidata i firmi */}
            <Nav.Link className={`sidebar-link ${activeTab === 'employer' ? 'active-link' : ''}`} onClick={() => setActiveTab('employer')}>
              <Building2 size={18} className="me-2" /> Employer Requests
            </Nav.Link>
          </Nav>

          <div className="sidebar-footer p-4 mt-auto">
            <div className="user-box mb-4">
              <small className="d-block text-white">Current User</small>
              <strong className="text-white truncate d-block">{adminEmail}</strong>
            </div>
            <Button
              variant="outline-danger"
              size="sm"
              className="w-100"
              onClick={() => {
                // 1. Brišemo APSOLUTNO SVE iz keša (Uništava adminToken i kompletan Microsoft/Google keš)
                localStorage.clear();
                sessionStorage.clear();

                // 2. Gasimo React stanje sa vrha aplikacije (za svaki slučaj)
                if (typeof setIsAuthenticated === 'function') {
                  setIsAuthenticated(false);
                }

                // 3. Preusmeravamo ruter na login stranicu
                navigate('/admin-portal-access');

                // 4. NUKLEARNA OPCIJA: Osvežavamo stranicu.
                // Ovo nasilno gasi sve "lude" Google/Microsoft skripte u pozadini i aplikacija kreće od nule čista!
                window.location.reload();
              }}
            >
              <LogOut size={14} className="me-2" /> Logout
            </Button>
          </div>
        </Col>

        {/* Main content ------------------------------------------------*/}
        <Col md={10} className="admin-main-content">
          <Container fluid className="p-5">
            <div className="d-flex justify-content-between align-items-center mb-5">
              <h2 className="dashboard-title">{getTitle()}</h2>

              {activeTab === 'jobs' && (
                <Button className="add-job-btn" onClick={() => { setIsEditMode(false); setShowModal(true); }}>
                  <Plus size={18} className="me-2" /> Post New Job
                </Button>
              )}

            </div>

            {/* Job table -----------------------------------------------*/}
            {activeTab === 'jobs' && (
              <>
                <div className="results-header mb-3">
                  <p className="mb-0 text-muted">
                    Showing <strong>{jobs.length === 0 ? 0 : indexOfFirstItem + 1}-{Math.min(indexOfLastItem, jobs.length)}</strong> of <strong>{jobs.length}</strong> Jobs
                  </p>
                </div>
                <div className="glass-table-card animate-in">
                  <Table responsive hover className="admin-table">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Date posted</th>
                        <th>Location</th>
                        <th>Category</th>
                        <th>Type</th>
                        {/* <th>Status</th> */}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentJobs.map(job => (
                        <tr key={job.id}>
                          <td className="fw-bold">{job.title}</td>
                          <td>{new Date(job.createdAt).toLocaleDateString()}</td>
                          <td>{job.location}</td>
                          <td>{job.category}</td>
                          <td>{job.type}</td>
                          {/* <td>{job.status.toUpperCase()}</td> */}
                          <td className="text-end">
                            <div className="d-flex gap-2">
                              <Button variant="outline-primary" size="sm" onClick={() => { setIsEditMode(true); setSelectedJob(job); setNewJob(job); setShowModal(true); }}>
                                <Pencil size={12} className="me-1" /> Edit
                              </Button>
                              <Button variant="outline-danger" size="sm" onClick={() => handleDeleteJob(job.id)}>
                                <Trash2 size={12} className="me-1" /> Delete
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {renderPagination(jobs.length)}
                </div>
              </>
            )}

            {/* Message table ------------------------------------------*/}
            {activeTab === 'messages' && (
              <>
                <div className="results-header mb-3">
                  <p className="mb-0 text-muted">
                    Showing <strong>{messages.length === 0 ? 0 : indexOfFirstItem + 1}-{Math.min(indexOfLastItem, messages.length)}</strong> of <strong>{messages.length}</strong> Messages
                  </p>
                </div>
                <div className="glass-table-card animate-in">
                  <Table responsive hover className="admin-table">
                    <thead>
                      <tr>
                        <th>From</th>
                        <th>Email</th>
                        <th>Subject</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentMessages.length > 0 ? (
                        currentMessages.map(msg => (
                          <tr key={msg.id}>
                            <td><strong>{msg.name}</strong></td>
                            <td>{msg.email}</td>
                            <td>{msg.subject}</td>
                            <td>{new Date(msg.createdAt).toLocaleDateString()}</td>
                            <td className="text-end">
                              <div className="d-flex gap-2">
                                <Button variant="outline-primary" size="sm" onClick={() => { setSelectedMessage(msg); setShowMessageModal(true); }}>
                                  <Eye size={12} className="me-1" /> Read
                                </Button>
                                <Button variant="outline-danger" size="sm" onClick={() => handleDeleteMessage(msg.id)}>
                                  <Trash2 size={12} /> Delete
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="5" className="text-center py-4">No messages found.</td></tr>
                      )}
                    </tbody>
                  </Table>
                  {renderPagination(generalMessages.length)}
                </div>
              </>
            )}
            {/* Job request table ----------------------------------------------------------*/}
            {activeTab === 'requests' && (
              <>
                <div className="results-header mb-3">
                  <p className="mb-0 text-muted">
                    Showing <strong>{requests.length === 0 ? 0 : indexOfFirstItem + 1}-{Math.min(indexOfLastItem, requests.length)}</strong> of <strong>{requests.length}</strong> Applications
                  </p>
                </div>
                <div className="glass-table-card animate-in">
                  <Table responsive hover className="admin-table">
                    <thead>
                      <tr>
                        <th>Candidate</th>
                        <th>Email</th>
                        <th>Applied For</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRequests.length > 0 ? currentRequests.map(req => (
                        <tr key={req.id}>
                          <td>
                            <strong>{req.candidateName}</strong><br />
                          </td>
                          <td>{req.candidateEmail}</td>
                          <td>{req.jobTitle}</td>
                          <td>{new Date(req.createdAt).toLocaleDateString()}</td>
                          <td>
                            <div className="d-flex gap-2">
                              {/* Dugme za CV */}
                              {req.cvPath && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  //href={`http://localhost:5000/uploads/cv/${req.cvPath}`}
                                  href={`/api-portal/uploads/cv/${req.cvPath}`}
                                  target="_blank"
                                  title="View CV"
                                >
                                  <FileText size={14} className="me-1" /> CV
                                </Button>
                              )}

                              {/* Cover letter button */}
                              <Button
                                variant="outline-info"
                                size="sm"
                                onClick={() => { setSelectedRequest(req); setShowRequestModal(true); }}
                                title="View Cover Letter"
                              >
                                <MessageSquare size={14} className="me-1" /> Letter
                              </Button>

                              {/* Button for deleting */}
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleDeleteRequest(req.id)}
                                title="Delete Application"
                              >
                                <Trash2 size={14} className="me-1" /> Delete
                              </Button>
                            </div>
                          </td>
                        </tr>
                      )) : (
                        <tr><td colSpan="4" className="text-center py-4">No applications received.</td></tr>
                      )}
                    </tbody>
                  </Table>
                  {renderPagination(requests.length)}
                </div>
              </>
            )}

            {/* Employer requests table ----------------------------------------------------*/}
            {activeTab === 'employer' && (
              <>
                <div className="results-header mb-3">
                  <p className="mb-0 text-muted">
                    Showing <strong>{employerInquiries.length === 0 ? 0 : indexOfFirstItem + 1}-{Math.min(indexOfLastItem, employerInquiries.length)}</strong> of <strong>{employerInquiries.length}</strong> Employer Inquiries
                  </p>
                </div>
                <div className="glass-table-card animate-in">
                  <Table responsive hover className="admin-table">
                    <thead>
                      <tr>
                        <th>Company / Contact</th>
                        <th>Email</th>
                        <th>Staff Needed</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentEmployerRequests.length > 0 ? (
                        currentEmployerRequests.map(msg => {
                          const companyName = msg.subject.replace('Employer Inquiry: ', '');
                          const staffNeededPart = msg.message.split('Staff Needed: ')[1];
                          const staffNeeded = staffNeededPart ? staffNeededPart.split('\n')[0] : 'N/A';

                          return (
                            <tr key={msg.id}>
                              <td>
                                <strong>{companyName}</strong><br />
                                <small className="text-muted">{msg.name}</small>
                              </td>
                              <td>{msg.email}</td>
                              <td>{staffNeeded}</td>
                              <td>{new Date(msg.createdAt).toLocaleDateString()}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <Button variant="outline-primary" size="sm" onClick={() => { setSelectedMessage(msg); setShowMessageModal(true); }}>
                                    <Eye size={12} className="me-1" /> View Details
                                  </Button>
                                  <Button variant="outline-danger" size="sm" onClick={() => handleDeleteMessage(msg.id)}>
                                    <Trash2 size={12} /> Delete
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr><td colSpan="5" className="text-center py-4">No employer inquiries found.</td></tr>
                      )}
                    </tbody>
                  </Table>
                  {renderPagination(employerInquiries.length)}
                </div>
              </>
            )}
          </Container>
        </Col>
      </Row>

      {/* Job modal ----------------------------------------------------*/}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? 'Edit Job' : 'Create Job Opening'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitJob}>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Job Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. Senior Warehouse Manager"
                    value={newJob.title}
                    onChange={e => setNewJob({ ...newJob, title: e.target.value })}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Location (City, State)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Orlando, Florida"
                    value={newJob.location}
                    onChange={e => setNewJob({ ...newJob, location: e.target.value })}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Specialism</Form.Label>
                  <Form.Select value={newJob.category} onChange={e => setNewJob({ ...newJob, category: e.target.value })}>
                    {categories.map(c => <option key={c} value={c}>{c}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Industry</Form.Label>
                  <Form.Select value={newJob.industry} onChange={e => setNewJob({ ...newJob, industry: e.target.value })}>
                    {industry.map(c => <option key={c} value={c}>{c}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Salary Range</Form.Label>
                  <Form.Select value={newJob.salary} onChange={e => setNewJob({ ...newJob, salary: e.target.value })}>
                    {salaryRanges.map(s => <option key={s} value={s}>{s}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Vacancy Type</Form.Label>
                  <Form.Select value={newJob.type} onChange={e => setNewJob({ ...newJob, type: e.target.value })}>
                    <option value="Full Time">Full Time</option>
                    <option value="Freelance">Freelance</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Career Level</Form.Label>
                  <Form.Select value={newJob.careerLevel} onChange={e => setNewJob({ ...newJob, careerLevel: e.target.value })}>
                    {careerLevels.map(cl => <option key={cl} value={cl}>{cl}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Experience</Form.Label>
                  <Form.Select value={newJob.experience} onChange={e => setNewJob({ ...newJob, experience: e.target.value })}>
                    {experiences.map(ex => <option key={ex} value={ex}>{ex}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Gender</Form.Label>
                  <Form.Select value={newJob.gender} onChange={e => setNewJob({ ...newJob, gender: e.target.value })}>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Both">Both</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Qualification</Form.Label>
                  <Form.Select value={newJob.qualification} onChange={e => setNewJob({ ...newJob, qualification: e.target.value })}>
                    {qualifications.map(q => <option key={q} value={q}>{q}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Full Job Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Describe responsibilities, requirements, etc."
                value={newJob.description}
                onChange={e => setNewJob({ ...newJob, description: e.target.value })}
                required
              />
            </Form.Group>

            <div className="text-end">
              {/* <Button variant="secondary" className="me-2" onClick={() => setShowModal(false)}>Cancel</Button> */}
              <Button type="submit" className="add-job-btn">
                {isEditMode ? 'Update Posting' : 'Publish Job'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal for reading messages */}
      <Modal show={showMessageModal} onHide={() => setShowMessageModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Message from {selectedMessage?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Subject:</strong> {selectedMessage?.subject}</p>
          <p><strong>From:</strong> {selectedMessage?.email}</p>
          <hr />
          <p style={{ whiteSpace: 'pre-wrap' }}>{selectedMessage?.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMessageModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for reading cover letters */}
      <Modal show={showRequestModal} onHide={() => setShowRequestModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cover Letter: {selectedRequest?.candidateName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Applied for: <strong>{selectedRequest?.jobTitle}</strong></h6>
          <hr />
          <p style={{ whiteSpace: 'pre-wrap' }}>
            {selectedRequest?.coverLetter || "No cover letter provided."}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRequestModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

    </div >
  );
};

export default AdminDashboard;